import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components';

export enum DcMarketPlaceIcons {
	Account = 'account',
	API = 'api',
	Check = 'check',
	Columns = 'columns',
	CopyFile = 'copy-file',
	CardView = 'grid-view',
	DcConsoleModule = 'dc-console-module',
	DcCoreModule = 'dc-core-module',
	DcCodeModule = 'dc-code-module',
	DcMaestroModule = 'dc-maestro-module',
	FilterQueryParams = 'filter-query-params',
	Help = 'help',
	ListView = 'list-view',
	LockOpen = 'lock-open',
	LockClose = 'lock-close',
	LoggerInheritance = 'logger-inheritance',
	Logout = 'logout',
	MarketPlaceLogo = 'marketplace-logo',
	Menu = 'menu',
	MenuMoreOptionsHandle = 'menu-more-options-open-handle',
	Profile = 'profile',
	Share = 'share',
	ShareOff = 'share-off',
	ResetSelection = 'reset-selection',
	ResultsNotFound = 'results-not-found',
	RoleAdminOrg = 'role-direct-admin',
	RoleMonitorLogs = 'monitors-log',
	Update = 'update',
	URLs = 'urls',
	Warning = 'warning',
}

@Injectable()
export class AppDcMarketPlaceIcons extends AppIcons {
	private readonly path = './assets/img';

	protected icons: IIcons = {
		[DcMarketPlaceIcons.Account]: `${this.path}/supervisor_account_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.API]: `${this.path}/api_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Check]: `${this.path}/check_circle_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.CopyFile]: `${this.path}/file_copy_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Columns]: `${this.path}/view_column_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.CardView]: `${this.path}/grid_on_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.DcConsoleModule]: `${this.path}/modules/DC-color-solo.svg`,
		[DcMarketPlaceIcons.DcCoreModule]: `${this.path}/modules/GD-color-solo.svg`,
		[DcMarketPlaceIcons.DcCodeModule]: `${this.path}/modules/DCC-logo-color.svg`,
		[DcMarketPlaceIcons.DcMaestroModule]: `${this.path}/modules/DCM-color-solo.svg`,
		[DcMarketPlaceIcons.FilterQueryParams]: `${this.path}/filter_alt_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Help]: `${this.path}/help_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.ListView]: `${this.path}/list_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.LockOpen]: `${this.path}/lock_open_right_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.LockClose]: `${this.path}/lock_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.LoggerInheritance]: `${this.path}/inheritance_propagation_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Logout]: `${this.path}/logout_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Menu]: `${this.path}/menu_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.MarketPlaceLogo]: `${this.path}/logo/dc_marketplace-light.svg`,
		[DcMarketPlaceIcons.MenuMoreOptionsHandle]: `${this.path}/more_vert_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcMarketPlaceIcons.Profile]: `${this.path}/profile_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Share]: `${this.path}/share_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.ShareOff]: `${this.path}/share_off_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.ResetSelection]: `${this.path}/reset_settings_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.ResultsNotFound]: `${this.path}/logo/search-results.svg`,
		[DcMarketPlaceIcons.RoleAdminOrg]: `${this.path}/role_direct_admin_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.RoleMonitorLogs]: `${this.path}/role_logs_direct_vital_signs_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Update]: `${this.path}/update_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.URLs]: `${this.path}/http_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcMarketPlaceIcons.Warning]: `${this.path}/warning_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
	};
}
